import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useDateFormat from "../../../hooks/useDateFormat";
import DeleteAcademyModal from "./modal/DeleteAcademyModal";
import DeleteIcon from "@mui/icons-material/Delete";
import useAcademy from "../../../hooks/useAcademy";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import AcademyModal from "./modal/AcademyModal";

export const TrainingCard = ({ training, triggerFetchTraining }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOn, setIsOn] = useState(training?.isActive);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { formatDate } = useDateFormat();
  const { toggleAcademy } = useAcademy();
  const [openAcademy, setOpenAcademy] = useState(false);

  const hanleAcademyClick = () => {
    navigate(`/settings/academy/module?trainingID=${training?._id}`, {
      state: { training },
    });
  };
  const handleToggle = async () => {
    const newState = !isOn;
    setIsOn(newState);
    const toggleName = "toggleActive";
    const resource = "training";
    try {
      await toggleAcademy(setLoading, training._id, resource, toggleName);
    } catch (error) {
      console.error("Failed to update training:", error);
      setIsOn(!newState);
    }
  };

  return (
    <>
      <div className="relative bg-white shadow-md rounded-lg overflow-hidden">
        <img
          src={training.thumbnail}
          alt={training.title}
          className="w-full h-40 object-cover"
        />
        <div className="p-4 bg-[#F1F1F1] flex justify-between ">
          <div
            onClick={hanleAcademyClick}
            className=" cursor-pointer hover:underline"
          >
            <h3 className="text-sm font-semibold text-gray-800">
              {training.title}
            </h3>
            <div className="flex flex-col mt-1">
              <span className="text-xs font-medium text-gray-800">
                {training.trainersName}
              </span>
              <span className="text-xs  text-gray-800 mt-1">
                Created at: {formatDate(training.createdAt)}
              </span>
            </div>
          </div>

          <div
            className="flex items-center cursor-pointer"
            onClick={handleToggle}
          >
            <img
              src={isOn ? "/toggleIconOn.svg" : "/toggleIconOff.svg"}
              alt="toggle icon"
              className="size-8"
            />
          </div>
        </div>
        <div
          onClick={() => setOpenDeleteModal(true)}
          className="absolute top-3 right-3 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <DeleteIcon className="text-red-500" fontSize="small" />
        </div>
        <div
          onClick={() => setOpenAcademy(true)}
          className="absolute top-3 right-11 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <ModeEditIcon fontSize="small" className="cursor-pointer " />
        </div>
      </div>
      {openDeleteModal && (
        <DeleteAcademyModal
          onTrigger={triggerFetchTraining}
          modalName={"Training"}
          setOpenDeleteModal={setOpenDeleteModal}
          name={training?.title}
          accademyCategory={4}
          createdBy={training?.trainersName}
          subCategory={training?.moduleCount}
          id={training?._id}
        />
      )}

      {openAcademy && (
        <AcademyModal
          onTrigger={triggerFetchTraining}
          setOpenAcademy={setOpenAcademy}
          training={training}
        />
      )}
    </>
  );
};
